import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen } from "lucide-react";

export default function CatalogueCTA({
  className = "",
  variant = "light",
  compact = false,
  code = "FOLIO",
}) {
  const classes = [
    "catalogue-cta",
    `catalogue-cta--${variant}`,
    compact ? "catalogue-cta--compact" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Link
      to="/catalogue"
      className={classes}
      aria-label="View Catalogue"
      onClick={() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }}
    >
      <span className="catalogue-cta-icon" aria-hidden="true">
        <BookOpen size={compact ? 14 : 16} strokeWidth={1.6} />
      </span>
      <span className="catalogue-cta-copy">
        <span className="catalogue-cta-code">{code}</span>
        <span className="catalogue-cta-label">View Catalogue</span>
      </span>
      <span className="catalogue-cta-arrow" aria-hidden="true">
        <ArrowUpRight size={compact ? 14 : 16} strokeWidth={1.7} />
      </span>
    </Link>
  );
}
